"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeEventListener = exports.addEventListener = exports.getAllFocusableElements = exports.KEYS = void 0;
var KEYS = {
  TAB: 9
};
exports.KEYS = KEYS;

var getAllFocusableElements = function getAllFocusableElements(context) {
  return Array.from(context.querySelectorAll('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'));
};

exports.getAllFocusableElements = getAllFocusableElements;

var addEventListener = function addEventListener(node, eventName, callback) {
  if (node.addEventListener) {
    node.addEventListener(eventName, callback);
  } else {
    node.attachEvent("on".concat(eventName), callback);
  }
};

exports.addEventListener = addEventListener;

var removeEventListener = function removeEventListener(node, eventName, callback) {
  if (node.removeEventListener) {
    node.removeEventListener(eventName, callback);
  } else {
    node.detachEvent("on".concat(eventName), callback);
  }
};

exports.removeEventListener = removeEventListener;
